import React, { Component } from 'react';
import { connect } from 'react-redux';
import {AuthActions} from '../../actions';
import {AppBar, Typography, Toolbar, Button} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {LeftNav} from './';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        height: '100%',
        zIndex: 1,
        position: 'relative',
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3,
        minWidth: 0, // So the Typography noWrap works
        marginLeft: '250px'
    },
    toolbar: theme.mixins.toolbar,
    flex: {
        flexGrow: 1,
    }
});

class RegularPage extends Component {
    logout() {
        this.props.dispatch(AuthActions.logout());
    }

    render() {
        const {classes, children} = this.props;
        return (
            <div className={classes.root}>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="title" color="inherit" noWrap className={classes.flex}>
                            Admin Dashboard
                        </Typography>
                        <Button color="inherit" onClick={this.logout.bind(this)}>Logout</Button>
                    </Toolbar>
                </AppBar>
                <LeftNav/>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {children}
                </main>
            </div>
        )
    }
}

const RegularPageWithRedux = withStyles(styles)(connect()(RegularPage));
export {RegularPageWithRedux as RegularPage};


// WEBPACK FOOTER //
// ./src/components/Templates/RegularPage.jsx